import { ReactNode } from "react";
import InputForm from "./InputForm";
import styles from "./newsletterWidgetTop.module.scss";

type NewsletterWidgetTopProps = {
  shareBtns?: ReactNode;
};

const NewsletterWidgetTop = ({ shareBtns }: NewsletterWidgetTopProps) => (
  <div className={styles.container}>
    <p className={styles.widgetText}>Subscribe to our newsletter</p>
    <div className={styles.subscribeAndShare}>
      <InputForm location="top" />
      {shareBtns ?? null}
    </div>
  </div>
);
export default NewsletterWidgetTop;
